import { Menu } from "@headlessui/react";

export const PromoteContextMenus = ({
    setAnchorShipmentEl,
    anchorShipmentEl,
    handlePromote,
    row
}) => {
    return (
        <>
            <Menu as="div" className="relative text-left">
                <div>
                    <Menu.Button
                        onClick={(e) => setAnchorShipmentEl(e.currentTarget)}
                        className="pt-1 pl-1 text-gray-800 hover:text-gray-900 rounded cursor-pointer"
                        title="More Actions..."
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                            width="18"
                            height="18"
                        >
                            <circle cx="12" cy="5" r="2" />
                            <circle cx="12" cy="12" r="2" />
                            <circle cx="12" cy="19" r="2" />
                        </svg>
                    </Menu.Button>
                </div>

                {anchorShipmentEl && (
                    <Menu.Items className="absolute z-10 bg-white border border-gray-300 rounded shadow-lg w-60 p-1 max-h-60 overflow-y-auto" style={{ left: '-200px' }}>
                        <div className="px-1 py-1">
                            {/* Subscribe Related Actions Section */}
                            <Menu.Item>
                                {({ active }) => (
                                    <button
                                        onClick={() => {
                                            handlePromote(row);
                                            setAnchorShipmentEl(null);
                                        }}
                                        className={`${active ? 'bg-gray-200' : ''
                                            } group flex rounded-md items-center w-full px-2 py-2 text-sm text-black`}

                                    >
                                        <svg xmlns="http:www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM13.4142 13.9997L15.182 15.7675L13.7678 17.1817L12 15.4139L10.2322 17.1817L8.81802 15.7675L10.5858 13.9997L8.81802 12.232L10.2322 10.8178L12 12.5855L13.7678 10.8178L15.182 12.232L13.4142 13.9997ZM9 4V6H15V4H9Z"></path></svg>
                                        <span className='mx-2'>Promote</span>
                                    </button>
                                )}
                            </Menu.Item>

                        </div>
                    </Menu.Items>
                )}
            </Menu>
        </>
    )
}